<template>
  <div class="site-footer">
    <div class="concat-us-inner container">
      <div class="concat-us-outer">
        <img class="img-b-logo" src="@/assets/img/logo-b.png" alt="" srcset="" />
        <div class="concat-us-item">服务热线：0731-86407968</div>
        <div class="concat-us-item" style="width: 322px; line-height: 24px; margin-bottom: 0">公司地址：中国（湖南）自由贸易试验区长沙片区长沙经开区区块三一路1号三一工业城众创楼3楼</div>
      </div>
      <div class="concat-us-outer">
        <div class="concat-us-item">
          <div class="fwh-qrcode-box">
            <div class="fwh-qrcode-box-it">
              <img src="@/assets/img/ewm1.png" alt="" srcset="" />
              <p>微信公众号</p>
            </div>
            <div class="fwh-qrcode-box-it">
              <img src="@/assets/img/ewm2.png" alt="" srcset="" />
              <p>微信小程序</p>
            </div>
          </div>
        </div>
      </div>
      <div class="concat-us-outer">
        <div class="jump-link">
          <p @click="handleSelect('/home')">网站首页</p>
          <p @click="handleSelect('/about-us')">关于云联</p>
          <p @click="handleSelect('/contact-us')">联系我们</p>
        </div>
        <div class="hot-line">
          <p>客服热线：9:00-17:00</p>
          <p>0731-86407968</p>
        </div>
        <div class="concat-us-item" style="text-align: right">三一云联技术有限公司</div>
        <div class="concat-us-item" style="text-align: right; margin-bottom: 0">网站备案号：<a href="https://beian.miit.gov.cn" style="text-decoration: none" target="_blank">湘ICP备2022013557号-1</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  components: {},
  methods: {
    handleSelect(val) {
      this.$router.push(val);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.site-footer {
  height: 305px;
  background: #363738;
  .concat-us-inner {
    height: 100%;
    display: flex;
    justify-content: space-between;
    padding: 53px 0;
    box-sizing: border-box;
    .concat-us-outer {
      .img-b-logo {
        width: 229px;
        height: 80px;
        margin-bottom: 17px;
      }
      .jump-link {
        display: flex;
        align-items: center;
        p {
          font-size: 16px;
          font-weight: 400;
          color: #b1b1b1;
          line-height: 18px;
          margin-left: auto;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .hot-line {
        width: 210px;
        height: 68px;
        background: #5c5c5c;
        margin: 34px 0;
        padding: 10px 16px;
        box-sizing: border-box;
        margin-left: auto;
        p {
          font-weight: bold;
          color: #b1b1b1;
          text-align: right;
          &:nth-child(1) {
            font-size: 16px;
            line-height: 18px;
          }
          &:nth-child(2) {
            font-size: 20px;
            line-height: 22px;
            margin-top: 8px;
          }
        }
      }
      .concat-us-item {
        font-size: 16px;
        font-weight: 400;
        color: #b1b1b1;
        line-height: 18px;
        margin-bottom: 10px;
        .fwh-qrcode-box {
          display: flex;
          align-items: center;
          .fwh-qrcode-box-it:first-child {
            margin-right: 60px;
          }
          img {
            width: 160px;
            height: 160px;
          }
          p {
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            color: #b1b1b1;
            margin-top: 20px;
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
